/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_ZipInputs */

const en__field_zip = /** @type {(inputs: _Field_ZipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zip`)
};

const de__field_zip = /** @type {(inputs: _Field_ZipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLZ`)
};

/**
* | output |
* | --- |
* | "Zip" |
*
* @param {_Field_ZipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_zip = /** @type {((inputs?: _Field_ZipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_ZipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_zip(inputs)
	return de__field_zip(inputs)
});